export const timezone = 'America/New_York';
export const locale = 'en-US';
